import React, {useState} from "react";
import {Button, Icon} from "semantic-ui-react";
import {holdTheShipment} from "../../commonApis";


function HoldShipmentButton(props){
    const shipId = props.shipId;
    const [holdingShipment, setHoldingShipment] = useState(false);
    const holdShipment = async () => {
        props.toggleLoaderFunc(); 
        setHoldingShipment(true)
        await holdTheShipment(shipId).then(async () => {
            setHoldingShipment(false)
        })
        props.toggleLoaderFunc("Please wait!!"); 
    }
    return(
        <Button
           id='holdshipment'
            size="mini"
            key='HOLD_SHIPMENT'
            circular
            icon={holdingShipment ? 'loading pause' : 'pause'}
            className="sv todo-button primaryBtn"
            title='Hold this shipment'
            onClick={(e) => {
                e.stopPropagation();
                holdShipment()
            }}
            />
    ) 
}
export default HoldShipmentButton;